<template>
    <div class="app-container">
        <div class="filter-head">
            <el-button type="primary" @click="handleAddTable">新增</el-button>
            <div class="status-filter">
                <el-select style="margin-right: 8px;" v-model="listQuery.state" placeholder="状态" clearable>
                    <el-option v-for="item in selectOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select>
                <el-button type="primary" @click="handleSearch">搜索</el-button>
            </div>
        </div>
        <div class="table">
            <el-table v-loading="listLoading" element-loading-text="Loading" :data="tableData" border fit
                highlight-current-row>
                <el-table-column type="index" label="序号" width="95" align="center" />
                <el-table-column prop="title" label="通知标题" min-width="110" align="center" />
                <el-table-column prop="content" label="通知描述" min-width="110" align="center" />
                <el-table-column prop="link_type" label="跳转类型" width="128" align="center">
                    <template #default="{ row: { link_type } }">
                        <el-tag type="primary" size="medium">{{ link_type | typeFilter }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" width="128" align="center">
                    <template #default="{ row: { state } }">
                        <el-tag :type="state ? 'success' : 'warning'">{{ state?"已发布": "待发布" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="release_at" label="发布时间" min-width="100" align="center" />
                <el-table-column label="操作" width="220" align="center" fixed="right">
                    <template #default="{ row }">
                        <el-button v-if="row.state == 0" size="mini" type="primary"
                            @click="handleEditTable(row)">编辑</el-button>

                        <el-button v-if="row.state == 0" size="mini" type="success"
                            @click="handlePublish(row.id)">发布</el-button>

                        <el-popconfirm title="确定删除?" @confirm="handleDelete(row.id)"   @onConfirm="handleDelete(row.id)" style="margin-left: 10px;">
                            <el-button type="danger" slot="reference" size="mini">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]"
                    :page-size="listQuery.limit" :total="total" background
                    layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
            </div>
        </div>

        <TableActionModal :show.sync="visible" :type="modalType" :edit-data="editData" @success="getList" />
    </div>
</template>

<script>
import { notification } from "@/api/operation"
import TableActionModal from './components/TableActionModal.vue';

export default {
    data: () => ({
        filter: {
            selectVal: null
        },
        selectOptions: [
            {
                value: 0,
                label: '待发布'
            }, {
                value: 1,
                label: '已发布'
            }
        ],
        listLoading: false,
        tableData: [],
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            state: "",
        },
        modalType: 'add',
        visible: false,
        editData: {
            link_type: 0
        }
    }),
    components: {
        TableActionModal
    },
    filters: {
        typeFilter(type) {
            switch (Number(type)) {
                case 1: return '活动';
                case 2: return '测评商品';
                case 3: return '公众号文章';
                case 4: return '平台内文章';
                case 5: return '无跳转'
            }
        }
    },
    methods: {
        getList() {
            this.listLoading = true
            notification.list(this.listQuery).then(({ data }) => {
                this.tableData = data.data
                this.total = data.total
                this.listLoading = false
            })
        },
        // 表格操作
        handleEditTable(e) {
            this.setModalType('edit')
            this.editData = e
            this.visible = true
        },
        handlePublish(id) {
            this.$confirm("此操作将该通知提上发布, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                notification.changeState(id).then(() => {
                    this.$message({
                        message: '操作成功!',
                        type: 'success'
                    });
                    this.getList()
                }).catch(() => { this.$message.error('操作失败!'); })
            })
        },
        handleDelete(id) {
            this.$confirm("此操作将删除该通知?", "注意", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                notification.delete(id).then(() => {
                    this.$message({
                        message: '操作成功!',
                        type: 'success'
                    });
                    this.getList()
                }).catch(() => { this.$message.error('操作失败!'); })
            })
        },
        // 分页操作
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        // 更改模式
        setModalType(type) {
            this.modalType = type
        },
        // 添加数据
        handleAddTable() {
            this.setModalType('add')
            this.visible = true
        },
        handleSearch() {
            this.listQuery.page = 1
            this.getList()
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style scoped lang="scss">
.filter-head {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .status-filter {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}

.table {
    margin-top: 10px;
}
</style>